import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";



const Servicesfaqs = [
  {
    question: "Who developed DevSecOps?",
    answer:
      "DevSecOps emerged as an evolution of DevOps practices, focusing on security integration into the development pipeline. It was developed by security professionals and DevOps teams to address increasing security challenges in modern software development.",
  },
  {
    question: "Is DevSecOps a good career?",
    answer:
      "Yes, DevSecOps is a promising career. As organizations prioritize security, the demand for skilled professionals to manage security in DevOps environments continues to grow.",
  },
  {
    question: "What does a DevSecOps do?",
    answer:
      "A DevSecOps professional ensures that security practices are integrated into the development and operations process. They automate security checks, monitor risks, and maintain a secure infrastructure throughout the software lifecycle",
  },
  {
    question: "Who is on a DevSecOps team?",
    answer:
      "A DevSecOps team typically includes DevOps engineers, security professionals, software developers, and IT specialists. These professionals work together to maintain a balance between security and development efficiency.",
  },
];

const DevSecOps = () => {
  const navigate = useNavigate();

  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null);

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>{" "}
            DevSecOps
          </h5>
          <h2>Build Secure Software from the Ground Up with DevSecOps</h2>
          <p>
            We help businesses implement robust security practices in their
            development processes, ensuring that security is never an
            afterthought.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Talk to an Expert
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as DevSecOps Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Comprehensive DevSecOps Services:
                </span>{" "}
                We specialize in embedding security practices throughout your
                development cycle. From development to deployment, our DevSecOps
                services ensure your systems are secure, scalable, and
                efficient.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  DevSecOps Consulting:
                </span>{" "}
                Our consulting services guide organizations through the
                complexities of adopting DevSecOps practices. We help businesses
                understand how to improve their development processes and
                maintain robust security at every stage.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  DevSecOps Framework:
                </span>{" "}
                We provide a clear and efficient framework to implement security
                in DevOps environments. Our structured approach ensures secure
                delivery from start to finish.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  DevSecOps Tools:
                </span>{" "}
                With our expertise in various DevSecOps products and tools, we
                select the right technologies to suit your specific needs. This
                ensures you can continuously monitor, test, and address security
                issues throughout your lifecycle.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Talk to an Expert
              <HiArrowNarrowRight className="psec1arrow" />
            </button>
          </section>
        </section>

        <section>
          <img
            className="s_sec2_img1"
            src="../images/I_devsecops_img.png"
            alt="devsecops"
          />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil as your DevSecOps Partner</h2>
          <p>
            Arshil ensures easy integration of security, development, and
            operations to meet your business goals effectively. As a leading
            DevSecOps partner, we prioritize:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ds_sec3_img1.png" alt="" />
            <h5>Enhanced Security</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ds_sec3_img2.png" alt="" />
            <h5>Efficient Development</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ds_sec3_img3.png" alt="" />
            <h5>Compiance Assurance</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_ds_sec3_img2.png" alt="" />
            <h5>Faster Deployment </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ds_sec3_img4.png" alt="" />
            <h5> Automated CI/CD Processes </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img6.png" alt="" />
            <h5> Expert Team </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach as your DevSeCops Partner </h1>
        <p>
          {" "}
          At Arshil, we follow a structured approach to ensure your applications
          are secure, efficient, and scalable. Here’s how we achieve this:
        </p>
        <ul className="Service_sec4_ul">
          <li>Assessment </li>
          <li>Strategy Development</li>
          <li>Implementation</li>
          <li>Continuous Monitoring and Improvement</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      {/* Sec 6 */}
      <div className="Sec8_container">
        <section>
          <h1>Ready to Secure Your Development Process?</h1>
          <p>
            Contact us to learn how our DevSecOps services can improve the
            security and efficiency of your development pipeline.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button
            onClick={() => navigate("/contact")}
            // onClick={() => Navigate("/contact")}
          >
            Talk to an Expert
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default DevSecOps;
